import React from 'react'

import { Card, CardHeading, CardContent } from '@components/layout/Card'

import { Grid } from '@UILibrary/Grid'
import { Text } from '@UILibrary/Text'

import FinancialHealthLineChart from '../shared/FinancialHealthLineChart'

import { Stat } from '../../../Shared/Stat'

interface ChartData {
  datasets: object
  labels: string[]
}

interface EmployeeDebtLevelsProps {
  averageDebtPayment: number
  averageIncome?: number
  benchmark: number
  benchmarkVariancePercentage: number
  currentDebtPercentage: number
  scopeVariancePercentage: number
  timeframe: string
  chartData: ChartData
}

export const EmployeeDebtLevels: React.FC<EmployeeDebtLevelsProps> = (props) => {
  return (
    <div id="employee-debt-levels">
      <Card>
        <CardHeading>
          <Text heading4a colour="secondary-main" as="h3" margin="none">
            What Percentage of Income Is Going Towards Debt Repayments?
          </Text>
          <Text body as="p" margin="none">
            A healthy income:debt ratio is considered to be below <strong>{props.benchmark}%</strong>. This calculation includes all team members, including those without debt.
          </Text>
        </CardHeading>
        <CardContent>
          <Text as="p" margin={{ bottom: 's' }}>
            Your team's average debt ratio is <strong>{props.currentDebtPercentage}%</strong>, which is <strong>{props.currentDebtPercentage < props.benchmark ? 'lower' : 'higher'}</strong> than the recommended maximum.
          </Text>
          <Grid cols="1-a" gap="m">
            <FinancialHealthLineChart
              height="medium"
              chartData={props.chartData}
              benchmark={props.benchmark}
            />
            <Stat percentage={props.scopeVariancePercentage} timeframe={props.timeframe} reverseCheck={true} />
          </Grid>
          <Text bodySmall as="p" textAlign='center' margin='none'>
            (click legends to toggle on and off)
          </Text>
        </CardContent>
      </Card>
    </div>
  )
}
